module.exports = __webpack_public_path__ + "static/media/wasafat_tabkh_icon_store.a787b7bb.png";